import {Field, Form, Formik} from "formik";
import {SaveButton} from "../../Pages/Bots/Elements/Config";
import {Container} from "react-bootstrap";
import * as React from "react";

export const Config = ({account, deleteAccount, onConfigSubmit, configFields, exchangeState}) => {
    return <Container fluid={true} className={"mt-3"}>
        <div>
            <Formik initialValues={exchangeState}
                    onSubmit={onConfigSubmit(account)} enableReinitialize={true}>
                {({isSubmitting}) => (
                    <Form>
                        <h4>Config</h4>
                        <div className={"row"}>
                            {Object.keys(configFields).map(key => (
                                <div key={key} className="form-group row col-sm-12">
                                    <label htmlFor={key} className={"col-sm-3 col-form-label"}>
                                        <b>{configFields[key]}</b>
                                    </label>
                                    <div className="col-sm-9">
                                        <Field type={"text"} name={key} id={key} className={"form-control"}
                                               disabled={isSubmitting}/>
                                    </div>
                                </div>
                            ))}
                            <SaveButton/>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
        <hr/>
        <button onClick={() => deleteAccount(account)} className={"btn btn-danger btn-block btn-sm"}>
            Delete account
        </button>
    </Container>
}